// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-plan-body[data-v-6a83fa61]{gap:5px}.select-plan-body i[data-v-6a83fa61]{font-size:20px}.select-plan-footer[data-v-6a83fa61]{gap:20px}.css-3ddbcp[data-v-6a83fa61]{z-index:10000!important}.has-text-secondary[data-v-6a83fa61]{color:var(--sds-color-text-secondary)!important}", ""]);
// Exports
module.exports = exports;
